import { render, staticRenderFns } from "./CommonModal.vue?vue&type=template&id=4634777c&scoped=true&"
import script from "./CommonModal.vue?vue&type=script&lang=js&"
export * from "./CommonModal.vue?vue&type=script&lang=js&"
import style0 from "./CommonModal.vue?vue&type=style&index=0&id=4634777c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4634777c",
  null
  
)

export default component.exports